import { useEffect, useState } from "react";
import styled from 'styled-components';
import { t } from '@lingui/core/macro';
import ResultList from "./ResultList";
import useStories from "./UseStories";
import {
  getTranslation
} from "./Utility.js"

const Input = styled.input`
  padding: 0.5rem;
  font-size: 1rem;
  border-radius: 0.25rem;
  border: 1px solid #ccc;
  margin-bottom: 1rem;
  background:papayawhip;
`;

const ResultContainer = styled.div`
  border: 1px solid #ccc;
  border-radius: 0.25rem;
  padding: 0.5rem;
  max-height: 200px;
  overflow-y: auto;
  background:#f2dcceb5;
`;

const AutoCompleteContainer = styled.div`
  padding: 1rem;
  margin-top: 2rem;
  /* height: 20vh; */
`;

const HelperText = styled.div`
  font-size: 0.75rem;
  color: #ccc;
`;

/**
 * A component to display an autocomplete search form
 * @param {object} props
 * @returns {JSX.Element}
 */
export function AutocompleteSearch(options) {
  const [searchTerm, setSearchTerm] = useState("");
  const [activeIndex, setActiveIndex] = useState(-1);

  useEffect(() => {
  }, []);

// Call for searched stories
  const { stories, loading } = useStories(
    "http://localhost:3000/api/items",
    searchTerm
  );

/**
   * A function that handles a search data change
   * @param {object} e - An event dom object
   * @returns {void} Set variables of state
   */
  const handleChange = (event) => {
    setSearchTerm(event.target.value);
  };

/**
   * A function that handles a select search data
   * @param {object} e - An event dom object
   * @returns {void} Call an option function or return boolean if fail
   */
  const handleSelect = (element) => {
    if (!element) {
      return false;
    }
    if (element.position && options.updateMap) {
      options.updateMap(element);
    }

  };

/**
   * A function that handles a key type event search data
   * @param {object} e - An event dom object
   * @returns {void} Set variables of state
   */
  const onKeyDown = (event) => {
    if (event.key === "ArrowDown") {
      setActiveIndex((prev) => (prev + 1) % stories.length);
    }
    if (event.key === "ArrowUp") {
      setActiveIndex((prev) => (prev - 1 + stories.length) % stories.length);
    }
    if (event.key === "Enter") {
      if(stories && stories.length > 0){
      setSearchTerm(stories[activeIndex].name);
      }

    }
  };


  return (
    <AutoCompleteContainer>
      <Input
      list="stories"
        onChange={handleChange}
        onKeyDown={onKeyDown}
        value={getTranslation(searchTerm)}
        placeholder={t`Search`}
      />
      <datalist id="stories">
<option value="Adventure sports center">{t`Adventure sports center`}</option>
<option value="Agricultural organization">{t`Agricultural organization`}</option>
<option value="Agricultural service">{t`Agricultural service`}</option>
<option value="Airport parking lot">{t`Airport parking lot`}</option>
<option value="Amphitheater">{t`Amphitheater`}</option>
<option value="Amusement center">{t`Amusement center`}</option>
<option value="Amusement park">{t`Amusement park`}</option>
<option value="Amusement park ride">{t`Amusement park ride`}</option>
<option value="Animal protection organization">{t`Animal protection organization`}</option>
<option value="Animal shelter">{t`Animal shelter`}</option>
<option value="Apartment complex">{t`Apartment complex`}</option>
<option value="Apartment rental agency">{t`Apartment rental agency`}</option>
<option value="Archaeological museum">{t`Archaeological museum`}</option>
<option value="Archaeological site">{t`Archaeological site`}</option>
<option value="Army museum">{t`Army museum`}</option>
<option value="Art center">{t`Art center`}</option>
<option value="Art museum">{t`Art museum`}</option>
<option value="Art studio">{t`Art studio`}</option>
<option value="Arts organization">{t`Arts organization`}</option>
<option value="Assisted living facility">{t`Assisted living facility`}</option>
<option value="Association / Organization">{t`Association / Organization`}</option>
<option value="Auto broker">{t`Auto broker`}</option>
<option value="Auto repair shop">{t`Auto repair shop`}</option>
<option value="Bank">{t`Bank`}</option>
<option value="Bar">{t`Bar`}</option>
<option value="Barbecue restaurant">{t`Barbecue restaurant`}</option>
<option value="Basilica">{t`Basilica`}</option>
<option value="Beach">{t`Beach`}</option>
<option value="Beauty salon">{t`Beauty salon`}</option>
<option value="Bed & breakfast">{t`Bed & breakfast`}</option>
<option value="Bicycle rental service">{t`Bicycle rental service`}</option>
<option value="Bistro">{t`Bistro`}</option>
<option value="Boat rental service">{t`Boat rental service`}</option>
<option value="Boat storage facility">{t`Boat storage facility`}</option>
<option value="Boat tour agency">{t`Boat tour agency`}</option>
<option value="Botanical garden">{t`Botanical garden`}</option>
<option value="Building firm">{t`Building firm`}</option>
<option value="Business to business service">{t`Business to business service`}</option>
<option value="Campground">{t`Campground`}</option>
<option value="Camping cabin">{t`Camping cabin`}</option>
<option value="Camping farm">{t`Camping farm`}</option>
<option value="Canoe & kayak rental service">{t`Canoe & kayak rental service`}</option>
<option value="Canoe & kayak tour agency">{t`Canoe & kayak tour agency`}</option>
<option value="Canoe and kayak club">{t`Canoe and kayak club`}</option>
<option value="Car racing venue">{t`Car racing venue`}</option>
<option value="Carabinieri police">{t`Carabinieri police`}</option>
<option value="Castle">{t`Castle`}</option>
<option value="Cathedral">{t`Cathedral`}</option>
<option value="Catholic church">{t`Catholic church`}</option>
<option value="Cemetery">{t`Cemetery`}</option>
<option value="Cheese shop">{t`Cheese shop`}</option>
<option value="Children's camp">{t`Children's camp`}</option>
<option value="City government office">{t`City government office`}</option>
<option value="City or town hall">{t`City or town hall`}</option>
<option value="City park">{t`City park`}</option>
<option value="Coast guard station">{t`Coast guard station`}</option>
<option value="Community center">{t`Community center`}</option>
<option value="Community garden">{t`Community garden`}</option>
<option value="Construction equipment supplier">{t`Construction equipment supplier`}</option>
<option value="Consultant">{t`Consultant`}</option>
<option value="Cooperative">{t`Cooperative`}</option>
<option value="Corporate office">{t`Corporate office`}</option>
<option value="Council">{t`Council`}</option>
<option value="Country food restaurant">{t`Country food restaurant`}</option>
<option value="Country park">{t`Country park`}</option>
<option value="Courier service">{t`Courier service`}</option>
<option value="Craft store">{t`Craft store`}</option>
<option value="Cultural center">{t`Cultural center`}</option>
<option value="Cultural landmark">{t`Cultural landmark`}</option>
<option value="Curtain supplier and maker">{t`Curtain supplier and maker`}</option>
<option value="Dairy">{t`Dairy`}</option>
<option value="Dance club">{t`Dance club`}</option>
<option value="Diner">{t`Diner`}</option>
<option value="Disco club">{t`Disco club`}</option>
<option value="Distillery">{t`Distillery`}</option>
<option value="Diving center">{t`Diving center`}</option>
<option value="Dog park">{t`Dog park`}</option>
<option value="Drilling contractor">{t`Drilling contractor`}</option>
<option value="Driver's license office">{t`Driver's license office`}</option>
<option value="E commerce agency">{t`E commerce agency`}</option>
<option value="Ecological park">{t`Ecological park`}</option>
<option value="Education center">{t`Education center`}</option>
<option value="Educational institution">{t`Educational institution`}</option>
<option value="Electric utility company">{t`Electric utility company`}</option>
<option value="Equestrian facility">{t`Equestrian facility`}</option>
<option value="Espresso bar">{t`Espresso bar`}</option>
<option value="Ethnographic museum">{t`Ethnographic museum`}</option>
<option value="Excavating contractor">{t`Excavating contractor`}</option>
<option value="Exhibit">{t`Exhibit`}</option>
<option value="Extended stay hotel">{t`Extended stay hotel`}</option>
<option value="Farm">{t`Farm`}</option>
<option value="Farm school">{t`Farm school`}</option>
<option value="Farmstay">{t`Farmstay`}</option>
<option value="Fine dining restaurant">{t`Fine dining restaurant`}</option>
<option value="Fishing charter">{t`Fishing charter`}</option>
<option value="Fortress">{t`Fortress`}</option>
<option value="Free parking lot">{t`Free parking lot`}</option>
<option value="Garden">{t`Garden`}</option>
<option value="Gardener">{t`Gardener`}</option>
<option value="Gas station">{t`Gas station`}</option>
<option value="Gastropub">{t`Gastropub`}</option>
<option value="General education school">{t`General education school`}</option>
<option value="Go-karting venue">{t`Go-karting venue`}</option>
<option value="Golf club">{t`Golf club`}</option>
<option value="Government hospital">{t`Government hospital`}</option>
<option value="Government office">{t`Government office`}</option>
<option value="Green energy supplier">{t`Green energy supplier`}</option>
<option value="Guest house">{t`Guest house`}</option>
<option value="Health spa">{t`Health spa`}</option>
<option value="Heliport">{t`Heliport`}</option>
<option value="Heritage museum">{t`Heritage museum`}</option>
<option value="Hiking area">{t`Hiking area`}</option>
<option value="Historical landmark">{t`Historical landmark`}</option>
<option value="History museum">{t`History museum`}</option>
<option value="Holiday apartment">{t`Holiday apartment`}</option>
<option value="Holiday apartment rental">{t`Holiday apartment rental`}</option>
<option value="Holiday home">{t`Holiday home`}</option>
<option value="Holiday park">{t`Holiday park`}</option>
<option value="Horse breeder">{t`Horse breeder`}</option>
<option value="Horse riding school">{t`Horse riding school`}</option>
<option value="Horseback riding service">{t`Horseback riding service`}</option>
<option value="Hostel">{t`Hostel`}</option>
<option value="Hotel">{t`Hotel`}</option>
<option value="Housing development">{t`Housing development`}</option>
<option value="Ice cream shop">{t`Ice cream shop`}</option>
<option value="Indoor lodging">{t`Indoor lodging`}</option>
<option value="Inn">{t`Inn`}</option>
<option value="Italian grocery store">{t`Italian grocery store`}</option>
<option value="Italian restaurant">{t`Italian restaurant`}</option>
<option value="Kennel">{t`Kennel`}</option>
<option value="Lake">{t`Lake`}</option>
<option value="Land surveying office">{t`Land surveying office`}</option>
<option value="Library">{t`Library`}</option>
<option value="Lido">{t`Lido`}</option>
<option value="Local government office">{t`Local government office`}</option>
<option value="Local history museum">{t`Local history museum`}</option>
<option value="Lodge">{t`Lodge`}</option>
<option value="Lodging">{t`Lodging`}</option>
<option value="Machine workshop">{t`Machine workshop`}</option>
<option value="Marble contractor">{t`Marble contractor`}</option>
<option value="Marina">{t`Marina`}</option>
<option value="Market">{t`Market`}</option>
<option value="Medical clinic">{t`Medical clinic`}</option>
<option value="Mediterranean restaurant">{t`Mediterranean restaurant`}</option>
<option value="Military airport">{t`Military airport`}</option>
<option value="Mine">{t`Mine`}</option>
<option value="Mineral water company">{t`Mineral water company`}</option>
<option value="Mobile home park">{t`Mobile home park`}</option>
<option value="Mountain cabin">{t`Mountain cabin`}</option>
<option value="Movie theater">{t`Movie theater`}</option>
<option value="Museum">{t`Museum`}</option>
<option value="National forest">{t`National forest`}</option>
<option value="National park">{t`National park`}</option>
<option value="Nature preserve">{t`Nature preserve`}</option>
<option value="News service">{t`News service`}</option>
<option value="Non-profit organization">{t`Non-profit organization`}</option>
<option value="Nursing home">{t`Nursing home`}</option>
<option value="Observation deck">{t`Observation deck`}</option>
<option value="Olive oil manufacturer">{t`Olive oil manufacturer`}</option>
<option value="Open air museum">{t`Open air museum`}</option>
<option value="Organic farm">{t`Organic farm`}</option>
<option value="Outdoor activity organiser">{t`Outdoor activity organiser`}</option>
<option value="Outdoor clothing and equipment shop">{t`Outdoor clothing and equipment shop`}</option>
<option value="Outdoor swimming pool">{t`Outdoor swimming pool`}</option>
<option value="Park">{t`Park`}</option>
<option value="Park & ride">{t`Park & ride`}</option>
<option value="Parking garage">{t`Parking garage`}</option>
<option value="Parking lot">{t`Parking lot`}</option>
<option value="Pet adoption service">{t`Pet adoption service`}</option>
<option value="Pet boarding service">{t`Pet boarding service`}</option>
<option value="Phone repair service">{t`Phone repair service`}</option>
<option value="Photo lab">{t`Photo lab`}</option>
<option value="Picnic ground">{t`Picnic ground`}</option>
<option value="Pizza restaurant">{t`Pizza restaurant`}</option>
<option value="Place of worship">{t`Place of worship`}</option>
<option value="Plumbing supply store">{t`Plumbing supply store`}</option>
<option value="Port authority">{t`Port authority`}</option>
<option value="Post office">{t`Post office`}</option>
<option value="Power station">{t`Power station`}</option>
<option value="Prison">{t`Prison`}</option>
<option value="Private hospital">{t`Private hospital`}</option>
<option value="Pub">{t`Pub`}</option>
<option value="Public beach">{t`Public beach`}</option>
<option value="Public library">{t`Public library`}</option>
<option value="Public parking space">{t`Public parking space`}</option>
<option value="Ranch">{t`Ranch`}</option>
<option value="Real estate agency">{t`Real estate agency`}</option>
<option value="Records storage facility">{t`Records storage facility`}</option>
<option value="Rehabilitation center">{t`Rehabilitation center`}</option>
<option value="Religious destination">{t`Religious destination`}</option>
<option value="Religious organization">{t`Religious organization`}</option>
<option value="Research institute">{t`Research institute`}</option>
<option value="Residents association">{t`Residents association`}</option>
<option value="Resort hotel">{t`Resort hotel`}</option>
<option value="Rest stop">{t`Rest stop`}</option>
<option value="Restaurant">{t`Restaurant`}</option>
<option value="Retirement home">{t`Retirement home`}</option>
<option value="Retreat center">{t`Retreat center`}</option>
<option value="Rock climbing">{t`Rock climbing`}</option>
<option value="Roofing contractor">{t`Roofing contractor`}</option>
<option value="Roofing supply store">{t`Roofing supply store`}</option>
<option value="RV park">{t`RV park`}</option>
<option value="Sardinian restaurant">{t`Sardinian restaurant`}</option>
<option value="Scenic spot">{t`Scenic spot`}</option>
<option value="Science museum">{t`Science museum`}</option>
<option value="Scooter rental service">{t`Scooter rental service`}</option>
<option value="Screen printing shop">{t`Screen printing shop`}</option>
<option value="Sculpture">{t`Sculpture`}</option>
<option value="Seafood restaurant">{t`Seafood restaurant`}</option>
<option value="Septic system service">{t`Septic system service`}</option>
<option value="Serviced accommodation">{t`Serviced accommodation`}</option>
<option value="Shelter">{t`Shelter`}</option>
<option value="Shipping and mailing service">{t`Shipping and mailing service`}</option>
<option value="Shipping service">{t`Shipping service`}</option>
<option value="Shopping mall">{t`Shopping mall`}</option>
<option value="Shrine">{t`Shrine`}</option>
<option value="Sightseeing tour agency">{t`Sightseeing tour agency`}</option>
<option value="Spa">{t`Spa`}</option>
<option value="Spa and health club">{t`Spa and health club`}</option>
<option value="Sporting goods store">{t`Sporting goods store`}</option>
<option value="Stadium">{t`Stadium`}</option>
<option value="State government office">{t`State government office`}</option>
<option value="State park">{t`State park`}</option>
<option value="Steak house">{t`Steak house`}</option>
<option value="Subway station">{t`Subway station`}</option>
<option value="Supermarket">{t`Supermarket`}</option>
<option value="Surf school">{t`Surf school`}</option>
<option value="Swimming pool">{t`Swimming pool`}</option>
<option value="Theme park">{t`Theme park`}</option>
<option value="Thermal baths">{t`Thermal baths`}</option>
<option value="Tour agency">{t`Tour agency`}</option>
<option value="Tour operator">{t`Tour operator`}</option>
<option value="Tourist attraction">{t`Tourist attraction`}</option>
<option value="Tourist information center">{t`Tourist information center`}</option>
<option value="Transportation service">{t`Transportation service`}</option>
<option value="Tsukigime parking lot">{t`Tsukigime parking lot`}</option>
<option value="Vacation home rental agency">{t`Vacation home rental agency`}</option>
<option value="Villa">{t`Villa`}</option>
<option value="Vineyard">{t`Vineyard`}</option>
<option value="Visitor center">{t`Visitor center`}</option>
<option value="Volunteer organization">{t`Volunteer organization`}</option>
<option value="Waste management service">{t`Waste management service`}</option>
<option value="Weather forecast service">{t`Weather forecast service`}</option>
<option value="Wedding venue">{t`Wedding venue`}</option>
<option value="Weir">{t`Weir`}</option>
<option value="Wellness center">{t`Wellness center`}</option>
<option value="Wellness hotel">{t`Wellness hotel`}</option>
<option value="Wildlife and safari park">{t`Wildlife and safari park`}</option>
<option value="Window supplier">{t`Window supplier`}</option>
<option value="Wine bar">{t`Wine bar`}</option>
<option value="Winery">{t`Winery`}</option>
<option value="Zoo">{t`Zoo`}</option>
</datalist>
 {searchTerm ? (
        <ResultContainer>
          <ResultList
            results={stories}
            searchTerm={searchTerm}
            loading={loading}
            handleSelect={handleSelect}
            activeIndex={activeIndex}
          />
        </ResultContainer>
      ) : (
        <HelperText>{t`Start typing to search`}</HelperText>
      )}
    </AutoCompleteContainer>
  );
}

export default AutocompleteSearch;